import React from 'react';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';
import { useLanguage, LANGUAGES, tr } from '@/i18n';
interface LanguageSwitcherProps {
  variant?: 'default' | 'ghost' | 'outline';
  size?: 'sm' | 'default' | 'lg';
  showFlag?: boolean;
  showText?: boolean;
}
export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  variant = 'ghost',
  size = 'sm',
  showFlag = true,
  showText = true
}) => {
  const {
    language,
    toggleLanguage
  } = useLanguage();
  const currentLang = LANGUAGES[language];
  return <Button variant={variant} size={size} onClick={toggleLanguage} className="gap-2 transition-all duration-200 hover:scale-105" title={tr('Switch to English', 'Переключить на русский', language)}>
      {showFlag ? <span className="text-base leading-none">{currentLang.flag}</span> : <Globe className="h-4 w-4" />}
      {showText && <span className="font-medium">
          {currentLang.code.toUpperCase()}
        </span>}
    </Button>;
};